module.exports = __webpack_public_path__ + "static/media/case1.0de988e8.png";